import React from 'react';
import { string } from 'prop-types';
import { SeIcon } from '@se/web-ui-react';
import { action_compare_hover } from '../../atoms/svg/action-compare-hover';
import { action_settings_hover } from '../../atoms/svg/action-settings-hover';
import { expandFullScreen, reduceFullScreen } from '../../atoms/svg/full-screen';
import { drag } from '../../atoms/svg/drag';

class MsxIcons extends React.Component {

  static propTypes = {
    name: string,
    color: string
  }

  render = () => {
    switch (this.props.name) {
      case 'add':
        return <SeIcon {...this.props}>action_add_stroke</SeIcon>
      case 'open-collapse':
        return <SeIcon {...this.props}>electricity_polarity_positive_plus</SeIcon>
      case 'close-collapse':
        return <SeIcon {...this.props}>electricity_polarity_negative_minus</SeIcon>
      case 'close':
        return <SeIcon {...this.props}>action_close</SeIcon>
      case 'modal-close':
        return <SeIcon {...this.props}>action_delete_cross</SeIcon>
      case 'done':
        return <SeIcon {...this.props}>notification_ok</SeIcon>
      case 'done-stroke':
        return <SeIcon {...this.props}>notification_ok_stroke</SeIcon>
      case 'edit':
        return <SeIcon {...this.props}>action_editor</SeIcon>
      case 'download':
        return <SeIcon {...this.props}>action_download_stroke</SeIcon>
      case 'filter':
        return <SeIcon {...this.props}>action_settings2</SeIcon>
      case 'info':
        return <SeIcon {...this.props}>information_stroke</SeIcon>
      case 'info_hover':
        return <SeIcon {...this.props}>information_circle</SeIcon>
      case 'copy':
        return <SeIcon {...this.props}>action_duplicate</SeIcon>
      case 'replace':
        return <SeIcon {...this.props}>data_refresh_stroke</SeIcon>
      case 'remove':
        return <SeIcon {...this.props}>action_close</SeIcon>
      case 'delete':
        return <SeIcon {...this.props}>action_delete</SeIcon>
      case 'menu-dots':
        return <SeIcon {...this.props}>other</SeIcon>
      case 'selected':
        return <SeIcon {...this.props}>notification_ok_wired</SeIcon>
      case 'selectable':
        return <SeIcon {...this.props}>onoff_off</SeIcon>
      case 'alert':
        return <SeIcon {...this.props}>general_danger_full</SeIcon>
      case 'back-arrow':
        return <SeIcon {...this.props}>arrow2_left</SeIcon>
      case 'right-arrow':
        return <SeIcon {...this.props}>arrow2_right</SeIcon>
      case 'up-arrow':
        return <SeIcon {...this.props}>arrow2_up</SeIcon>
      case 'down-arrow':
        return <SeIcon {...this.props}>arrow2_down</SeIcon>
      case 'left-arrow':
        return <SeIcon {...this.props}>arrow2_left</SeIcon>
      case 'bold-up-arrow':
        return <SeIcon {...this.props}>arrow3_up</SeIcon>
      case 'bold-down-arrow':
        return <SeIcon {...this.props}>arrow3_down</SeIcon>  
      case 'eye-show':
        return <SeIcon {...this.props}>body_eye</SeIcon>
      case 'eye-hide':
        return <SeIcon {...this.props}>eye_dont_show</SeIcon>
      case 'settings':
        return <SeIcon {...this.props}>action_settings1</SeIcon>
      case 'settings_hover':
        return action_settings_hover;
      case 'io-types':
        return <SeIcon {...this.props}>action_compare</SeIcon>
      case 'io-types_hover':
        return action_compare_hover;
      case 'pacdrive-adjust':
        return <SeIcon {...this.props}>action_distribute_horizontal_center</SeIcon>
      case 'datasheet':
        return <SeIcon {...this.props}>page</SeIcon>
      case 'go-to-start':
        return <SeIcon {...this.props}>action_logout</SeIcon>
      case 'expand':
        return <SeIcon {...this.props}>presentation_mode</SeIcon>
      case 'configuration':
        return <SeIcon {...this.props}>existing_project</SeIcon>
      case 'range':
        return <SeIcon {...this.props}>device_breaker</SeIcon>
      case 'power-supply':
        return <SeIcon {...this.props}>calculation_launch_powerbalance</SeIcon>
      case 'protocol':
        return <SeIcon {...this.props}>connection_router</SeIcon>
      case 'login':
        return <SeIcon {...this.props}>user_standard</SeIcon>
      case 'location':
        return <SeIcon {...this.props}>map_location</SeIcon>
      case 'lock':
        return <SeIcon {...this.props}>action_lock_on</SeIcon>
      case 'search':
        return <SeIcon {...this.props}>action_search_stroke</SeIcon>
      case 'filter2':
        return <SeIcon {...this.props}>action_filter</SeIcon>
      case 'share':
        return <SeIcon {...this.props}>action_share</SeIcon>
      case 'export':
        return <SeIcon {...this.props}>action_doc_export_stroke</SeIcon>
      case 'list':
        return <SeIcon {...this.props}>list</SeIcon>
      case 'mail':
        return <SeIcon {...this.props}>mail</SeIcon>
      case 'filter-link':
        return <SeIcon {...this.props}>action_layer_backward</SeIcon>
      case 'new-project':
        return <SeIcon {...this.props}>new_project</SeIcon>
      case 'favorites':
        return <SeIcon {...this.props}>favourites_addto</SeIcon>
      case 'ecommerce':
        return <SeIcon {...this.props}>segment_retail</SeIcon>
      case 'tools':
        return <SeIcon {...this.props}>tools</SeIcon>
      case 'skipped':
          return <SeIcon {...this.props}>action_redo</SeIcon>
      case 'software-link':
          return <SeIcon {...this.props}>action_new_window</SeIcon>
      case 'about':
          return <SeIcon {...this.props}>about</SeIcon>
      case 'previous':
        return <SeIcon {...this.props}>action_previous</SeIcon>
      case 'expand-full-screen':
        return expandFullScreen;
      case 'reduce-full-screen':
        return reduceFullScreen;
      case 'drag':
        return drag;

      default:
    }
    return '';
  }
}

export default MsxIcons;
